import { gql } from "@urql/core";

export const DOCUMENT_TEMPLATE_LIST_QUERY = gql`
  query DocumentTemplateList(
    $filter: JSONObject
    $sorting: [SortInput!]
    $paging: PaginationInput
  ) {
    documentTemplates(query: { filter: $filter, sorting: $sorting, paging: $paging }) {
      nodes {
        id
        documentName
        category
        tag
        createdAt
        updatedAt
      }
    }
  }
`;

export const DOCUMENT_TEMPLATE_ONE_QUERY = gql`
  query DocumentTemplateOne($id: String!) {
    documentTemplate(id: $id) {
      id
      documentName
      category
      tag
      templateId
      fileId
      url
      createdBy
      updatedBy
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_DOCUMENT_TEMPLATE_MUTATION = gql`
  mutation CreateDocumentTemplate($input: CreateDocumentTemplateInput!) {
    createDocumentTemplate(input: $input) {
      id
      documentName
      category
      tag
      templateId
      fileId
      url
      createdBy
      updatedBy
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_DOCUMENT_TEMPLATE_MUTATION = gql`
  mutation UpdateDocumentTemplate($id: String!, $input: UpdateDocumentTemplateInput!) {
    updateDocumentTemplate(id: $id, input: $input) {
      id
      documentName
      category
      tag
      templateId
      fileId
      url
      createdBy
      updatedBy
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_DOCUMENT_TEMPLATE_MUTATION = gql`
  mutation DeleteDocumentTemplate($id: String!) {
    deleteDocumentTemplate(id: $id) {
      id
    }
  }
`;